import { useTranslation } from 'react-i18next'

import { DotsLoader, PageTemplateContent } from 'app/common/templates-next/page-template'
import PlainNav, { NavItem } from 'app/common/ui-next/plain-nav'
import PlainLinkAsButton from 'app/common/ui-next/plain-link-as-button'
import { FundSection } from 'app/dataTypes/acquiring/settings'
import Link from 'app/common/lib/link'

import styles from './FundNavigation.scss'


type Props = {
  activeFundSection: FundSection
  showRefillLink: boolean
  refillLink: string
  showTransferLink: boolean
  transferLink: string
  showReturnLink: boolean
  returnLink: string
  loading?: boolean
}

const FundNavigation = ({
  activeFundSection,
  showRefillLink,
  refillLink,
  showTransferLink,
  transferLink,
  showReturnLink,
  returnLink,
  loading,
}: Props) => {
  const { t } = useTranslation('finances')

  return (
    <PageTemplateContent horizontalLayout>
      <PlainNav className={styles.nav} NavComponent={Link}>
        {showRefillLink
          && <NavItem to={refillLink} active={activeFundSection === FundSection.Refill}>
            {t('refill_menu_item1', 'Пополнить счет')}
          </NavItem>}

        {showTransferLink
          && <NavItem to={transferLink} active={activeFundSection === FundSection.Transfer}>
            {t('refill_menu_item2', 'Перевести')}
          </NavItem>}

        {loading
          && <div>
            &nbsp;
            <DotsLoader simple />
          </div>}
      </PlainNav>

      {showReturnLink
        && <PlainLinkAsButton to={returnLink}>
          {t('back_to_start_bt', 'Вернуться в начало')}
        </PlainLinkAsButton>}
    </PageTemplateContent>
  )
}

export default FundNavigation
